// This file is not yet translated.
/* eslint-disable i18next/no-literal-string */
import { Box, Image, Theme, Typography } from "@outschool/backpack";
import { useTranslation } from "@outschool/localization";
import { dayjs } from "@outschool/time";
import {
  Container,
  CurvedTopper
} from "@outschool/ui-legacy-component-library";
import React from "react";

import CollageGirl from "../../../images/Collage—Girl3.png";

export default function ContentfulPageHeader({ page }: { page: any }) {
  const { t } = useTranslation(
    "client\\components\\contentful\\ContentfulPageHeader"
  );
  return (
    <Box
      sx={{
        backgroundColor: "#F0F3FF"
      }}
    >
      <Container sx={{ paddingY: "1em" }}>
        <Box
          flex
          sx={(theme: Theme) => ({
            alignItems: "stretch",

            [theme.breakpoints.up("md")]: {
              alignItems: "center",
              flexDirection: "row"
            },

            flexDirection: "column",
            gap: "1em"
          })}
        >
          <Box
            flex
            sx={{
              flex: 1,
              flexDirection: "column"
            }}
          >
            <Typography variant="display1">{page.title}</Typography>
            {page.publishedAt && (
              <Typography
                variant="inherit"
                sx={{
                  fontSize: "1em",
                  fontWeight: "fontWeightMedium"
                }}
              >
                {t("Last updated {{date}}", {
                  date: dayjs(page.publishedAt).format("LL")
                })}
              </Typography>
            )}
          </Box>
          <Box
            sx={(theme: Theme) => ({
              position: "relative",
              display: "none",

              [theme.breakpoints.up("md")]: {
                display: "block"
              },

              flex: 1,
              maxWidth: "500px"
            })}
          >
            <Image
              src={page.headerImage?.url || CollageGirl}
              sx={{
                width: 500,
                height: 500
              }}
              alt={
                page.headerImage?.description ?? t`A generic photo of a person`
              }
            />
          </Box>
        </Box>
      </Container>
      <CurvedTopper color="white" />
    </Box>
  );
}
